import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, timeout } from 'rxjs';

// Request timeout defaults to 30 seconds, also applies to GraphQL requests
export const REQUEST_TIMEOUT = new HttpContextToken<number>(() => 30000);

/**
 * Cancels requests after a specific timeout, configurable via HttpContextToken `REQUEST_TIMEOUT` (client/server)
 */
@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(timeout(req.context.get(REQUEST_TIMEOUT)));
  }
}
